import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["flatDiscountField", "perAmountFields", "bonusFields"];

  connect() {
    this.toggleFields();
  }

  toggleFields(event) {
    const selectedType = event ? event.target.value : this.getSelectedOfferType();

    this.flatDiscountFieldTarget.style.display = "none";
    this.perAmountFieldsTarget.style.display = "none";
    this.bonusFieldsTarget.style.display = "none";

    if (selectedType === "flat") {
      this.flatDiscountFieldTarget.style.display = "block";
    } else if (selectedType === "per_amount") {
      this.perAmountFieldsTarget.style.display = "block";
    } else if (selectedType === "bonus") {
      this.bonusFieldsTarget.style.display = "block";
    }
  }

  getSelectedOfferType() {
    const selected = this.element.querySelector('input[name="product_offers_request[offer_type]"]:checked');
    return selected ? selected.value : null;
  }
}
